import { EpsQuote } from "./microapp-eps.quote.model";

export class EpsTenantQuotas {
    tenant_id: string
    name: string
    quota: EpsQuote[]
    non_entitled_associations_enabled:boolean
}